<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="createAutoMatchDialog" max-width="1400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Create Auto Match</v-card-title
                >
                <div v-if="!showMatchResults">
                    <v-layout row>
                        <v-select
                            :items="['FAMILY', 'STUDENT']"
                            label="Match Type"
                            v-model="type"
                            class="mr-3"
                            disabled
                        ></v-select>
                        <v-text-field
                            v-model="autoMatchTitle"
                            label="Title"
                            ref="title"
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-layout>
                    <div style="overflow-y: auto; height: 500px">
                        <v-layout
                            row
                            class="font-weight-medium"
                            v-if="type == 'FAMILY'"
                        >
                            <div class="mr-2">
                                Master List:
                            </div>
                            ({{ getMasterListCount() }})
                            <div class="mx-2">
                                Selected:
                            </div>
                            ({{ selected.length }})
                        </v-layout>

                        <dx-grid
                            class="voting-matching-list px-0"
                            url="voting?phoneNumber="
                            name="voting-matching-master-list"
                            :columns="votingColumns"
                            :selectionEnabled="true"
                            v-bind:disableExporting="true"
                            v-bind:hideHeader="true"
                            v-bind:hideActions="true"
                            v-bind:disableStoring="true"
                            ref="votingGrid"
                            :onLoaded="onMasterListLoaded"
                            :onSelected="onMasterListSelected"
                        ></dx-grid>
                    </div>
                    <v-card-actions class="mr-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeCreateAutoMatchDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            @click="loadMatchResults"
                            >Continue</v-btn
                        >
                    </v-card-actions>
                </div>

                <div v-if="showMatchResults">
                    <v-layout
                        row
                        justify-center
                        class="font-weight-medium title"
                    >
                        {{ getMatchesCount() }}
                        <div class="mx-2">
                            Matches
                        </div>
                    </v-layout>
                    <DxDataGrid
                        :data-source="matchResults"
                        key-expr="personID"
                        :show-borders="true"
                    >
                        <DxColumn
                            caption="Person"
                            data-field="person"
                            :group-index="0"
                        />
                        <DxColumn caption="DOE ID" data-field="regID" />
                        <DxColumn caption="First" data-field="first" />
                        <DxColumn caption="Last" data-field="last" />
                        <DxColumn caption="Address" data-field="address" />
                        <DxColumn caption="DOB" data-field="dob" />
                        <DxColumn
                            caption="Registered On"
                            data-field="datE_REG"
                        />

                        <DxGroupPanel :visible="true" />
                        <DxGrouping :auto-expand-all="true" />
                        <DxPaging :page-size="10" />
                        <DxSearchPanel :visible="true" />
                    </DxDataGrid>

                    <v-card-actions class="mr-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeCreateAutoMatchDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            color="default"
                            outline
                            @click="showMatchResults = false"
                            >Back</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            @click="saveAutoMatch"
                            >Save</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="createStudentAutoMatchDialog"
            max-width="1400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Create Auto Match</v-card-title
                >
                <div v-if="!showMatchResults">
                    <v-layout row>
                        <v-select
                            :items="['FAMILY', 'STUDENT']"
                            label="Match Type"
                            v-model="type"
                            class="mr-3"
                            disabled
                        ></v-select>
                        <v-text-field
                            v-model="autoMatchTitle"
                            label="Title"
                            ref="title"
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-layout>
                    <div style="overflow-y: auto; height: 500px">
                        <v-layout
                            row
                            class="font-weight-medium"
                            v-if="type == 'STUDENT'"
                        >
                            <div class="mr-2">
                                Student List:
                            </div>
                            ({{ getStudentListCount() }})
                            <div class="mx-2">
                                Selected:
                            </div>
                            ({{ studentsSelected.length }})
                        </v-layout>
                        <dx-grid
                            class="voting-matching-list px-0"
                            url="ygStudents?includeInactive="
                            name="student-matching-list"
                            :columns="studentColumns"
                            :selectionEnabled="true"
                            v-bind:disableExporting="true"
                            v-bind:hideHeader="true"
                            v-bind:hideActions="true"
                            v-bind:disableStoring="true"
                            ref="studentsGrid"
                            :onLoaded="onStudentListLoaded"
                            :onSelected="onStudentListSelected"
                        ></dx-grid>
                    </div>
                    <v-card-actions class="mr-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeCreateAutoMatchDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            @click="loadStudentsMatchResults"
                            >Continue</v-btn
                        >
                    </v-card-actions>
                </div>

                <div v-if="showMatchResults">
                    <v-layout
                        row
                        justify-center
                        class="font-weight-medium title"
                    >
                        {{ getMatchesCount() }}
                        <div class="mx-2">
                            Matches
                        </div>
                    </v-layout>
                    <DxDataGrid
                        :data-source="matchResults"
                        key-expr="id"
                        :show-borders="true"
                    >
                        <DxColumn caption="ID" data-field="id" />
                        <DxColumn caption="First" data-field="first" />
                        <DxColumn caption="Last" data-field="last" />
                        <DxColumn caption="First Heb" data-field="firstH" />
                        <DxColumn caption="Last Heb" data-field="lastH" />
                        <DxColumn caption="Address" data-field="address1" />
                        <DxColumn caption="DOB" data-field="dob" />
                        <DxColumn caption="ANSL Name" data-field="anslName" />
                        <DxColumn
                            caption="ANSL Heb Name"
                            data-field="anslNameHeb"
                        />
                        <DxColumn
                            caption="ANSL Address"
                            data-field="anslAddress"
                        />
                        <DxGrouping :auto-expand-all="true" />
                        <DxPaging :page-size="10" />
                        <DxSearchPanel :visible="true" />
                    </DxDataGrid>

                    <v-card-actions class="mr-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeCreateAutoMatchDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            color="default"
                            outline
                            @click="showMatchResults = false"
                            >Back</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            @click="saveAutoMatch"
                            >Save</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="createStudentToDoeAutoMatchDialog"
            max-width="1400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Create Auto Match Student To Doe</v-card-title
                >
                <div v-if="!showMatchResults">
                    <v-layout row>
                        <v-select
                            :items="['FAMILY', 'STUDENT', 'STUDENT TO DOE']"
                            label="Match Type"
                            v-model="type"
                            class="mr-3"
                            disabled
                        ></v-select>
                        <v-text-field
                            v-model="autoMatchTitle"
                            label="Title"
                            ref="title"
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-layout>
                    <div style="overflow-y: auto; height: 500px">
                        <v-layout
                            row
                            class="font-weight-medium"
                            v-if="type == 'STUDENT TO DOE'"
                        >
                            <div class="mr-2">
                                Student List:
                            </div>
                            ({{ getStudentListCount() }})
                            <div class="mx-2">
                                Selected:
                            </div>
                            ({{ studentsSelected.length }})
                        </v-layout>
                        <dx-grid
                            class="voting-matching-list px-0"
                            url="ygStudents?includeInactive="
                            name="student-matching-list"
                            :columns="studentColumns"
                            :selectionEnabled="true"
                            v-bind:disableExporting="true"
                            v-bind:hideHeader="true"
                            v-bind:hideActions="true"
                            v-bind:disableStoring="true"
                            ref="studentsToDoeGrid"
                            :onLoaded="onStudentListLoaded"
                            :onSelected="onStudentListSelected"
                        ></dx-grid>
                    </div>
                    <v-card-actions class="mr-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeCreateAutoMatchDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            @click="loadStudentsToDoeMatchResults"
                            >Continue</v-btn
                        >
                    </v-card-actions>
                </div>

                <div v-if="showMatchResults">
                    <v-layout
                        row
                        justify-center
                        class="font-weight-medium title"
                    >
                        {{ getMatchesCount() }}
                        <div class="mx-2">
                            Matches
                        </div>
                    </v-layout>
                    <DxDataGrid
                        :data-source="matchResults"
                        key-expr="id"
                        :show-borders="true"
                    >
                        <DxColumn caption="ID" data-field="id" />
                        <DxColumn caption="First" data-field="first" />
                        <DxColumn caption="Last" data-field="last" />
                        <DxColumn caption="First Heb" data-field="firstH" />
                        <DxColumn caption="Last Heb" data-field="lastH" />
                        <DxColumn caption="Address" data-field="address1" />
                        <DxColumn caption="DOB" data-field="dob" />
                        <DxColumn caption="DOE ID" data-field="regID" />
                        <DxColumn
                            caption="Registered On"
                            data-field="datE_REG"
                        />

                        <DxGrouping :auto-expand-all="true" />
                        <DxPaging :page-size="10" />
                        <DxSearchPanel :visible="true" />
                    </DxDataGrid>

                    <v-card-actions class="mr-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeCreateAutoMatchDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            color="default"
                            outline
                            @click="showMatchResults = false"
                            >Back</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            @click="saveAutoMatch"
                            >Save</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
//import { formatCurrency } from "../utils/helpers.js";
import DxCheckBox from "devextreme-vue/check-box";
import {
    DxDataGrid,
    DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
} from "devextreme-vue/data-grid";
import moment from "moment";

export default {
    components: {
        DxCheckBox,
        DxColumn,
        DxGroupPanel,
        DxGrouping,
        DxPaging,
        DxSearchPanel,
        DxDataGrid,
    },
    data: () => ({
        title: "Auto Match",
        matchDialog: false,
        createAutoMatchDialog: false,
        createStudentAutoMatchDialog: false,
        createStudentToDoeAutoMatchDialog: false,
        clickedRow: {},
        selected: [],
        matchResults: [],
        type: "FAMILY",
        autoMatchTitle: "",

        userID: "",
        processing: false,
        url: "",
        actions: [],

        masterListCount: 0,

        showMatchResults: false,

        studentsListCount: 0,
        studentsSelected: [],

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                field: "title",
                label: "Title",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "type",
                label: "Type",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortIndex: 0,
                sortOrder: "desc",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "byUser",
                label: "By User",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "total",
                label: "Total",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        votingColumns: [
            {
                field: "titleHebrew",
                label: "Title Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstHebrew",
                label: "First Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastHebrew",
                label: "Last Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstEnglish",
                label: "First English",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastEnglish",
                label: "Last English",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "personID",
                label: "Person ID",
                //link: "DinnerAccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "city",
                label: "City",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "state",
                label: "State",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "zip",
                label: "Zip",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchCount",
                label: "Match Count",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "utaStudentCount",
                label: "Students",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "phone",
                label: "Phone",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        studentColumns: [
            // {
            //     label: "ID",
            //     field: "id",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Last Name",
                field: "last",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "first",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name Heb",
                field: "lastH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name Heb",
                field: "firstH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "School Source",
                field: "schoolName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Import Source",
                field: "source",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Apt",
                field: "apt",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "City",
                field: "city",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "County",
            //     field: "county",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            // {
            //     label: "State",
            //     field: "state",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Zip",
                field: "zip",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Father ID",
            //     field: "fatherID",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            // {
            //     label: "DOB",
            //     field: "dob",
            //     format: "MM/dd/yyyy",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            // {
            //     label: "Phone",
            //     field: "phone",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            // {
            //     label: "Gander",
            //     field: "gander",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            // {
            //     label: "Status",
            //     field: "status",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
        ],
    }),
    created() {},
    methods: {
        beforeSetupGrid() {
            this.actions.push({
                text: "Create Auto Match - Families To DOE",
                action: this.openAutoMatchDialog,
            });

            this.actions.push({
                text: "Create Auto Match - Student To Family",
                action: this.openStudentAutoMatchDialog,
            });

            this.actions.push({
                text: "Create Auto Match - Student To DOE",
                action: this.openStudentToDoeAutoMatchDialog,
            });

            this.url = "votingRegistrationAutoMatch";
        },
        async onRowClicked(row) {
            //this.clickedRow = row;

            this.$router.push({
                name: "VotingRegistrationAutoMatchDetails",
                params: { id: row.id },
            });
        },
        reset() {
            if (this.$refs.votingGrid) {
                this.$refs.votingGrid.resetAllFilters();
            }

            if (this.$refs.studentsGrid) {
                this.$refs.studentsGrid.resetAllFilters();
            }
        },
        getMasterListCount() {
            if (!this.$refs.votingGrid) return 0;

            return this.$refs.votingGrid.getTotalCount();
        },
        onMasterListLoaded(data) {
            if (!this.$refs.votingGrid) return 0;

            this.masterListCount = this.$refs.votingGrid.getTotalCount() || 0;
            this.selected = this.$refs.votingGrid.getSelectedRowsData();
        },
        onMasterListSelected(selected) {
            this.selected = selected || [];
        },
        onStudentListSelected(selected) {
            this.studentsSelected = selected || [];
        },
        onStudentListLoaded(data) {
            if (!this.$refs.studentsGrid) return 0;

            this.studentsListCount =
                this.$refs.studentsGrid.getTotalCount() || 0;
            this.studentsSelected = this.$refs.studentsGrid.getSelectedRowsData();
        },
        getStudentListCount() {
            if (!this.$refs.studentsGrid) return 0;

            return this.$refs.studentsGrid.getTotalCount();
        },
        // async loadMatches(personID) {
        //     const matches = await this.$http.get(
        //         "api/voting/getMatches?personID=" + personID
        //     );

        //     this.matches = matches
        //         .filter((m) => !m.removed)
        //         .map((match) => {
        //             match.address = match.house + " " + match.street;

        //             return match;
        //         });
        // },
        openAutoMatchDialog() {
            this.type = "FAMILY";
            this.createAutoMatchDialog = true;

            this.$refs.votingGrid.clearSelection();
        },
        openStudentAutoMatchDialog() {
            this.type = "STUDENT";
            this.createStudentAutoMatchDialog = true;

            this.$refs.studentsGrid.clearSelection();
        },
        openStudentToDoeAutoMatchDialog() {
            this.type = "STUDENT TO DOE";
            this.createStudentToDoeAutoMatchDialog = true;

            this.$refs.studentsToDoeGrid.clearSelection();
        },
        closeCreateAutoMatchDialog() {
            this.createAutoMatchDialog = false;
            this.createStudentAutoMatchDialog = false;
            this.createStudentToDoeAutoMatchDialog = false;
            this.showMatchResults = false;
            this.matchResults = [];
            this.selected = [];
        },
        async loadMatchResults() {
            this.selected = this.$refs.votingGrid.getSelectedRowsData();

            if (!this.selected.length) {
                return this.$notify({
                    text: "Nothing Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.title.validate(true)) return;

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/votingRegistrationAutoMatch/GetMatchingDOE",
                    this.selected.map((s) => s.personID),
                );

                this.matchResults = response
                    .map((p) => {
                        const matches = p.matches;
                        const person = p.person;

                        matches.forEach((match) => {
                            match.personID = person.personID;
                            match.person =
                                "(" +
                                person.personID +
                                ") " +
                                person.firstHebrew +
                                " " +
                                person.lastHebrew;

                            match.address =
                                match.house +
                                " " +
                                match.street +
                                " " +
                                match.apt;
                            match.datE_REG = moment(match.datE_REG).format("L");
                        });

                        return matches;
                    })
                    .flat();

                this.showMatchResults = true;

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async loadStudentsMatchResults() {
            this.studentsSelected = this.$refs.studentsGrid.getSelectedRowsData();

            if (!this.studentsSelected.length) {
                return this.$notify({
                    text: "Nothing Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.title.validate(true)) return;

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/votingRegistrationAutoMatch/GetStudentMatchingAnsl",
                    this.studentsSelected.map((s) => s.id),
                );

                this.matchResults = response.map((s) => {
                    s.student.anslName =
                        s.match.firstEnglish + " " + s.match.lastEnglish;
                    s.student.anslNameHeb =
                        s.match.firstHebrew + " " + s.match.lastHebrew;
                    s.student.anslAddress = s.match.address1;
                    s.student.address1 =
                        s.student.address1 + " " + s.student.apt;
                    s.student.dob = moment(s.student.dob).format("L");
                    s.student.personID = s.match.personID;

                    return s.student;
                });

                this.showMatchResults = true;

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async loadStudentsToDoeMatchResults() {
            this.studentsSelected = this.$refs.studentsToDoeGrid.getSelectedRowsData();

            if (!this.studentsSelected.length) {
                return this.$notify({
                    text: "Nothing Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.title.validate(true)) return;

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/votingRegistrationAutoMatch/GetStudentMatchingDoe",
                    this.studentsSelected.map((s) => s.id),
                );

                this.matchResults = response.map((s) => {
                    s.student.datE_REG = moment(s.match.datE_REG).format("L");
                    s.student.address1 =
                        s.student.address1 + " " + s.student.apt;
                    s.student.dob = moment(s.student.dob).format("L");
                    s.student.doeID = s.match.reG_ID;
                    s.student.regID = s.match.reG_ID;

                    return s.student;
                });

                this.showMatchResults = true;

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        getMatchesCount() {
            return this.matchResults.length;
        },
        async saveAutoMatch() {
            if (!this.matchResults.length) {
                return this.$notify({
                    text: "No Matches",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/votingRegistrationAutoMatch/SaveMatches",
                    {
                        date: moment().format("YYYY-MM-DD HH:mm:ss"),
                        byUser: this.$store.state.authentication.user,
                        title: this.autoMatchTitle,
                        type: this.type,
                        autoMatchDetails: this.matchResults.map((match) => ({
                            doeID: ["FAMILY", "STUDENT TO DOE"].includes(
                                this.type,
                            )
                                ? match.regID
                                : null,
                            studentID: ["STUDENT", "STUDENT TO DOE"].includes(
                                this.type,
                            )
                                ? match.id
                                : null,
                            personID: match.personID,
                            status: "Pending",
                        })),
                    },
                );

                this.$notify({
                    group: "notification",
                    text: "Matches Saved",
                    type: "success",
                });

                this.closeCreateAutoMatchDialog();

                this.$refs.grid.reloadGrid();
                //this.$refs.votingGrid.reloadGrid();

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.accounts-search.container {
    padding-top: 0px;
}
.doe-table .vgt-table th {
    padding: 0.2em 1.5em 0em 0.75em !important;
}
.doe-table table.vgt-table td {
    padding: 0.5em 0.75em 0.5em 0.75em !important;
}
.doe-table .table.vgt-table {
    font-size: 14px !important;
}
.doe-table .vgt-table th.filter-th {
    padding: 0.2em 0.75em 0.5em 0.75em !important;
}
.selected-tab {
    color: rgb(76, 175, 80) !important;
    border-bottom: 1px solid rgb(76, 175, 80) !important;
}

.voting-matching-list-grid.container {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
}
.voting-matching-list-grid .v-card__text {
    padding-top: 4px !important;
}
.voting-matching-list-grid .flex {
    padding: 0px !important;
}
.voting-matching-list-grid .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
